<template>
  <el-container class="ContractPrint">
    <el-main class="p-0 pb-default">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="품질보증서" name="1">
          <div class="print-area">
            <div ref="warranty">
              <QRWarranty 
                v-for="(good, index) in goods"
                :key="index"
                :config="config.warranty" 
                :data="good"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="컨트롤스티커" name="2">
          <div class="print-area" v-if="activeTab === '2'">
            <div ref="control">
              <BarcodeControl 
                v-for="(good, index) in controlGoods"
                :key="index"
                :config="config.control" 
                :data="good"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="박스스티커" name="3">
          <div class="print-area" v-if="activeTab === '3'">
            <div ref="box">
              <BarcodeBox 
                v-for="(good, index) in goods"
                :key="index"
                :config="config.box" 
                :data="good"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="출고스티커" name="4">
          <div class="print-area" v-if="activeTab === '4'">
            <div ref="out">
              <BarcodeOut 
                v-for="(product, index) in products"
                :key="index"
                :config="config.out" 
                :data="product"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="인쇄 옵션"
        top="120px"
        width="300px"
        :visible.sync="dialog_visible"
        :close-on-click-modal="false"
        :modal="false"
        destroyOnClose
      >
        <PrintConfig 
          ref="config" 
          v-if="dialog_visible" 
          @completed="handleCompletedPrintConfig" 
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >{{$t('button.print')}} (F8)</el-button>
      <el-button
        @click="handleClickPrintConfig"
      >인쇄 옵션</el-button>
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from "vuex";
import Print from '@/plugins/print/print'
import { print_config } from '@/common/mixins/print_config'
import QRWarranty from '@/spa/Common/QRWarranty'
import BarcodeControl from '@/spa/Common/BarcodeControl'
import BarcodeBox from '@/spa/Common/BarcodeBox'
import BarcodeOut from '@/spa/Common/BarcodeOut'
import PrintConfig from '@/spa/Common/PrintConfig'

Vue.use(Print);

export default {
  name: "ContractPrint",
  mixins: [print_config],
  components: {QRWarranty, BarcodeControl, BarcodeBox, PrintConfig, BarcodeOut},
  data() {
    return {
      activeTab: "1",
      contract: undefined,
      dialog_visible: false,
      config: {},
      products: [],
      goods: [],
      details: [],
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
  },
  computed: {
    ...mapGetters(["table_product"]),
    controlGoods() {
      return this.goods.length > 0? this.goods: this.details;
    },
  },
  mounted() {
    this.loadConfig();
    this.organizeData();
  },
  methods: {
    loadConfig() {
      let item = this.loadPrintConfig();
      if (!item) { return; }
      this.util.copyObject(item.value, this.config);
    },
    organizeData() {
      let goods = [];
      let details = [];
      let products = [];
      this.data.forEach(contract => {
        details.push({
          customer_name: contract.customer_name,
          contract_code: contract.code,
        });
        contract.details.forEach(detail => {
          products.push({
            contract_code: contract.code,
            customer_name: contract.customer_name,
            contract_date: contract.contract_date,
            product_name: detail.product_name,  
          });
          let specification = this.util.getSpecification(detail, contract.details);
          detail.goods.forEach(good => {
            goods.push({
              code: good.code,
              contract_code: contract.code,
              customer_name: contract.customer_name,
              contract_date: contract.contract_date,
              delivery_date: contract.delivery_date,
              product_id: detail.product_id,
              field: detail.field,
              desc: detail.desc,
              size: good.size,
              sizes: this.getSize(good),
              specification: specification,
            });
          });
        });
      });
      this.goods = goods;
      this.details = details;
      this.products = products;
    }, 
    getSize(good) {
      let product = this.table_product.find(p => p.id === good.product_id);
      return this.util.calculateSize(good.size, product);
    },
    handleClickPrint() {
      switch(this.activeTab) {
        case '1':
          this.$print(this.$refs.warranty);
          break;
        case '2':
          this.$print(this.$refs.control);
          break;
        case '3':
          this.$print(this.$refs.box);
          break;
        case '4':
          this.$print(this.$refs.out);
          break;
      }
    },
    handleClickPrintConfig() {
      this.dialog_visible = true;
    },
    handleCompletedPrintConfig() {
      this.dialog_visible = false;
      this.loadConfig();
    },
    handleClickClose() {
      this.$emit('completed');
    },
  }
}
</script>
<style lang="scss" scoped>
.print-area {
  height: 600px;
  overflow: auto;
}
</style>